export enum CustomProductsSearchBoxFacets {
  CATEGORY = 'category',
  // PRICE = 'price',
  // BRAND = 'brand'
}
